const comps = import.meta.glob("../../views/**/*.vue");

/**
 * This will lazy load a view component
 *
 * @param {String} view The file path of the view component
 * @returns Asynchronous view component
 */
export default function (view) {
  return comps[`../../views/${view}.vue`];
}
